import Api from './rest/SpecChatApi';

export default new Api();
